import {
  ShineBorder as BaseShineBorder,
  type ShineBorderProps,
} from "@/components/ui/shine-border"

export function ShineBorder(props: ShineBorderProps) {
  return <BaseShineBorder shineColor="var(--foreground)" {...props} />
}

export type { ShineBorderProps }
